import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { CheckboxInput, Dialog, DialogActions, DialogContent } from '@guildeducationinc/recess';
import { useClients } from '@src/hooks/useClients';
import { ADD_CHILD_CLIENTS, DataTable, TrackableButton, useAlert, useLocale, } from 'pe-core-frontend';
import { useState } from 'react';
export const AddChildClients = ({ parentId, onClose }) => {
    const [showModal, setShowModal] = useState(false);
    const { t } = useLocale();
    const [selectedClientIds, setSelectedClientIds] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const { clients, page, pageSize, setPage, setPageSize, total } = useClients({
        excludeChildren: true,
        skip: !showModal,
    });
    const [updateChildClients] = useMutation(ADD_CHILD_CLIENTS);
    const { showAlert } = useAlert();
    const handleClose = () => {
        setShowModal(false);
        setSelectedClientIds([]);
        onClose();
    };
    const handleSave = async () => {
        setShowModal(false);
        setIsSaving(true);
        try {
            await updateChildClients({
                variables: { input: { clientIds: selectedClientIds, parentId } },
            });
            showAlert(t('Child clients updated successfully'));
            handleClose();
        }
        catch (error) {
            showAlert(t('Error updating child clients'));
            console.error(error);
        }
        finally {
            setIsSaving(false);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(TrackableButton, { btnType: 'mui', enText: 'Add Clients', tag: 'header', variant: 'contained', onClick: () => setShowModal(true), children: t('Add Clients') }), _jsxs(Dialog, { title: t('Add Clients'), isOpen: showModal, onClose: handleClose, fullScreen: true, forceDisableFocusTrap: true, children: [_jsx(DialogContent, { children: _jsx(DataTable, { disableColumnMenu: true, disableRowSelectionOnClick: true, disableColumnSelector: true, onRowClick: ({ row }) => {
                                if (selectedClientIds.includes(row.id)) {
                                    setSelectedClientIds(selectedClientIds.filter(id => id !== row.id));
                                }
                                else {
                                    setSelectedClientIds([...selectedClientIds, row.id]);
                                }
                            }, columns: [
                                {
                                    field: 'isSelected',
                                    headerName: t('Selected'),
                                    width: 100,
                                    sortable: false,
                                    renderCell: ({ row }) => (_jsx(CheckboxInput, { label: t('Selected'), hideLabel: true, checked: selectedClientIds.includes(row.id), onChange: e => {
                                            e.stopPropagation();
                                            if (e.target.checked) {
                                                setSelectedClientIds([...selectedClientIds, row.id]);
                                            }
                                            else {
                                                setSelectedClientIds(selectedClientIds.filter(id => id !== row.id));
                                            }
                                        } })),
                                },
                                {
                                    field: 'name',
                                    headerName: t('Name'),
                                    flex: 0.2,
                                    sortable: false,
                                },
                            ], rows: clients, pageSizeOptions: [10, 25], paginationMode: 'server', paginationModel: { page: page - 1, pageSize }, onPaginationModelChange: pagination => {
                                const newPage = pagination.page + 1;
                                const newPageSize = pagination.pageSize;
                                if (newPage !== page || newPageSize !== pageSize) {
                                    setPage(newPage);
                                    setPageSize(newPageSize);
                                }
                            }, rowCount: total }) }), _jsxs(DialogActions, { fullScreen: false, children: [_jsx(TrackableButton, { enText: 'Cancel', tag: 'add_child_clients', appearance: 'outline', onClick: handleClose, disabled: isSaving, children: t('Cancel') }), _jsx(TrackableButton, { enText: 'Submit', tag: 'add_child_clients', onClick: () => handleSave(), disabled: isSaving, children: t('Submit') })] })] })] }));
};
